import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from './utils/metaPixel';
export function PricingCTA() {
  return <section id="pricing" className="py-14 px-4 bg-neutral-950 relative overflow-hidden" data-id="element-89">
      {/* Glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand/10 blur-[120px] rounded-full pointer-events-none" data-id="element-90" />

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-neutral-900 border-2 border-brand/30 rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(255,107,0,0.1)]" data-id="element-92">
          <div className="flex justify-center mb-6" data-id="element-93">
            <div className="bg-brand/10 text-brand p-3 rounded-full" data-id="element-94">
              <ShieldCheck size={48} data-id="element-95" />
            </div>
          </div>

          <h2 className="text-4xl md:text-5xl font-display text-white mb-6" data-id="element-96">
            Protegé a tu michi por menos de lo que cuesta una bolsa de
            piedritas.
          </h2>

          <p className="text-xl text-neutral-300 mb-6 max-w-2xl mx-auto" data-id="element-97">
            Accedé a la Guía de Primeros Auxilios Felinos y llevate todos los
            bonos de acción rápida hoy mismo.
          </p>

          <div className="mb-6" data-id="element-98">
            <div className="text-neutral-400 text-lg font-medium mb-2 uppercase tracking-widest" data-id="element-99">
              Precio Especial
            </div>
            <div className="text-6xl md:text-8xl font-display text-brand drop-shadow-[0_0_15px_rgba(255,107,0,0.5)]" data-id="element-100">
              $9.499 <span className="text-3xl text-neutral-500" data-id="element-101">ARS</span>
            </div>
          </div>

          <Button href="https://amigospeludosarg.shop/cart/49119681052914:1" size="xl" className="w-full md:w-auto text-lg md:text-xl py-6 px-12 mb-4" onClick={trackAddToCart} data-id="element-102">
            ¡QUIERO EL PROTOCOLO DE EMERGENCIA AHORA!
          </Button>

          <p className="text-neutral-500 font-medium" data-id="element-103">
            Recibís el acceso inmediato en tu email tras el pago.
          </p>
        </motion.div>
      </div>
    </section>;
}